import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IToastState {
  error: Array<string>;
  message: Array<string>; 
}

const initState = {
  error: Array<string>(), message: Array<string>()
} as IToastState

const authSlice = createSlice({
  name: 'auth',
  initialState: initState as IToastState,
  reducers: {
    errorAdded: (
      state,
      action: PayloadAction<Array<string>>
    ): IToastState => {
      return {
        ...state,
        error: action.payload
      }
    },  
    messageAdded: (
      state,
      action: PayloadAction<Array<string>>
    ): IToastState => {
      return {
        ...state,
        message: action.payload
      }
    },
    errorCleared: (
      state
    ): IToastState => {
      return {
        ...state,
        error: Array<string>()
      }
    },  
    messageCleared: (
      state,    
    ): IToastState => {
      return {
        ...state,
        message: Array<string>()
      }
    }   
  }
})

export const {
  errorAdded, 
  messageAdded,
  errorCleared,
  messageCleared
} = authSlice.actions

export default authSlice.reducer